/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useQuery } from "@tanstack/react-query";
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { ErrorType } from "../../apix-handler";
import type {
  GetResultFiltersResponse,
  LegacyFiltersByFilterTypeGetV2Params,
  ResultFilterType,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const legacyFiltersByFilterTypeGetV2 = (
  filterType: ResultFilterType,
  params?: LegacyFiltersByFilterTypeGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<GetResultFiltersResponse>(
    {
      url: `/apix/v2/LegacyFilters/${filterType}`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getLegacyFiltersByFilterTypeGetV2QueryKey = (
  filterType?: ResultFilterType,
  params?: LegacyFiltersByFilterTypeGetV2Params,
) => {
  return [
    `/apix/v2/LegacyFilters/${filterType}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getLegacyFiltersByFilterTypeGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof legacyFiltersByFilterTypeGetV2>>,
  TError = ErrorType<unknown>,
>(
  filterType: ResultFilterType,
  params?: LegacyFiltersByFilterTypeGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof legacyFiltersByFilterTypeGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getLegacyFiltersByFilterTypeGetV2QueryKey(filterType, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof legacyFiltersByFilterTypeGetV2>>
  > = ({ signal }) =>
    legacyFiltersByFilterTypeGetV2(filterType, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!filterType,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof legacyFiltersByFilterTypeGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LegacyFiltersByFilterTypeGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof legacyFiltersByFilterTypeGetV2>>
>;
export type LegacyFiltersByFilterTypeGetV2QueryError = ErrorType<unknown>;

export function useLegacyFiltersByFilterTypeGetV2<
  TData = Awaited<ReturnType<typeof legacyFiltersByFilterTypeGetV2>>,
  TError = ErrorType<unknown>,
>(
  filterType: ResultFilterType,
  params?: LegacyFiltersByFilterTypeGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof legacyFiltersByFilterTypeGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLegacyFiltersByFilterTypeGetV2QueryOptions(
    filterType,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
